import { Supplier } from "@/v2/types";
import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";
import FindAllSupplier from "@/v2/api/supplier/FindAll";

interface SupplierFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function SupplierFilterComboBox({
    value,
    onChange,
    placeholder = "Select supplier...",
    disabled = false,
    className,
    label = "Supplier",
}: SupplierFilterComboBoxProps) {
    const handleSelect = (item: Supplier | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderEmployeeItem = (supplier: Supplier) => (
        <div className="flex flex-col">
            <span>{supplier.full_name}</span>
            {supplier.short_code && (
                <span className="text-xs text-muted-foreground">
                    {supplier.short_code}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<Supplier>
            label={label}
            labelAlign="items-start"
            queryKey={["clients"]}
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllSupplier({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(supplier: Supplier) => supplier.full_name}
            renderItem={renderEmployeeItem}
            placeholder={placeholder}
            searchPlaceholder="Search supplier..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
